module.exports = __webpack_public_path__ + "img/20200912_154939.25b3a91e.jpg";